export default __webpack_public_path__ + "static/media/icon-stamp-white.ec0d511b.svg";